export default "__VITE_ASSET__58AdSHIT__"